export default __webpack_public_path__ + "media/rm_r.2a9b5998.mov";